<div>
  <app-base-report *ngIf="withdrawalData"
                   [hasDateRangeFilter]="true"
                   [hasCheckboxes]="true"
                   [filterFields]="filterField"
                   [reportName]="'Admin Withdrawal Report'"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="withdrawalData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChange($event)"
                   [customSelectionRows]="selectableRows"
                   [selectionActions]="selectionActions"
                   (selectionActionTrigger)="selectionTrigger($event)"
                   [selectionModel]="selectionModel"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="fetchWithdrawalsService"
                   [tableLoading]="loading">
  </app-base-report>
</div>
